import {fetchHelper, simulateDelay} from '../utils/requestUtils';

export const getSourceTypeMany = async () => {
    await simulateDelay();
    const response = await fetchHelper({
        method: "GET",
        url: "/sourceTypes/getMany",
    })
    return response;
}
